import { useStore } from "@nanostores/react";
import clsx from "clsx";
import { useRouter } from "next/navigation";
import { garantiStore, setTypeValues, updateUrl } from "../../_utils/searchStore";

export const Garanti = () => {
  const router = useRouter();
  const selectedGaranti = useStore(garantiStore);

  return (
    <label
      className={clsx(
        "cursor-pointer flex items-center gap-1.5 select-none rounded-[36px] p-1 pr-2.5 transition-colors",
        {
          "bg-[#DBF8F8]": !selectedGaranti,
          "bg-[#16C4C4]": selectedGaranti,
        },
      )}
    >
      <div className="relative">
        <input
          type="checkbox"
          className="hidden peer"
          checked={selectedGaranti}
          onChange={(e) => {
            if (e.target.checked) {
              setTypeValues("garanti", [
                {
                  type: "garanti",
                  value: "true",
                },
              ]);
              updateUrl(router);
            } else {
              setTypeValues("garanti", []);
              updateUrl(router);
            }
          }}
        />
        <div className="w-10 h-6 bg-[#9BE3E3] peer-checked:bg-[#055D5D] rounded-[36px] transition-colors" />
        <div className="absolute w-5 h-5 rounded-full left-0.5 top-0.5 bg-white peer-checked:translate-x-[16px] transition-transform" />
      </div>
      <p
        className={clsx("text-xs/[14px] font-semibold transition-colors", {
          "text-white": selectedGaranti,
          "text-[#16C4C4]": !selectedGaranti,
        })}
      >
        Départ garanti
      </p>
    </label>
  );
};
